import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../interfaces/user';
import { environment } from '../../environments/environment';
import { HtmlService } from './htmlservice';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseUrl = environment.baseUrl;
  private urlPersist = this.baseUrl + "/api/User";

  constructor(private http: HttpClient, private htmlService: HtmlService) { }

  addUser(user: User): Observable<any[]>{
    const headers = this.htmlService.getAnonymousHeaders();
    const result = this.http.post<any[]>(this.urlPersist, user, {headers});
    return result;
  }

  updateUser(user: User): Observable<any[]>{
    const headers = this.htmlService.getHeaders();
    let result = this.http.patch<any[]>(`${this.urlPersist}/${user.id}`, user, {headers});
    return result;
  }

  deleteUser(): Observable<any[]>{
    const headers = this.htmlService.getHeaders();
    let result = this.http.delete<any[]>(this.urlPersist, {headers});
    return result;
  }
}